import { API_ENDPOINT } from '@/constant/constant.ts'

type IResLogin = {
    token?: string;
    turnstileRequired?: boolean;
    loginFailCount?: number;
}

export interface IReqLogin {
    id: string
    password: string
    turnstileToken?: string
}

export const apiLogin = async (params: IReqLogin) => {
    try {
        const endpoint = `${API_ENDPOINT}/auth/login`
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
            credentials: 'include',
        })

        const res = await response.json()
        return {
            data: res.data as IResLogin | undefined,
            code: res.code as number,
            message: res.message as string,
            turnstileRequired: res.turnstileRequired as boolean | undefined,
            loginFailCount: res.loginFailCount as number | undefined,
        }
    } catch {
        return {
            data: undefined,
            code: 500,
            message: '서버에 연결할 수 없습니다',
            turnstileRequired: undefined,
            loginFailCount: undefined,
        }
    }
}
